import React from 'react';

import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { Alert, Box, Stack } from '@mui/material';

import { getChoiceCampaignSelections } from '~/utils/luxLoyaltyChoiceCampaigns';

interface Props {
  earnDecisions: App.LuxLoyaltyAccount['earnDecisions'];
}

/**
 * A thin notification bar per active Société choice campaign the member has chosen in, e.g. "Choose Your Double
 * Rewards: Double Points activated". Renders nothing when there's no active choice.
 */
export default function LuxLoyaltyChoiceCampaignStrip({ earnDecisions }: Props) {
  const selections = getChoiceCampaignSelections(earnDecisions);

  if (!selections.length) {
    return null;
  }

  return (
    <Stack spacing={1}>
      {selections.map(({ catalogId, campaignName, choiceLabel }) => (
        <Alert
          key={catalogId}
          severity="info"
          icon={<CampaignOutlinedIcon fontSize="small" />}
          sx={{
            borderRadius: 2,
            py: 0,
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiAlert-icon': { py: 0.75, mr: 1 },
            '& .MuiAlert-message': { py: 0.75 },
          }}
        >
          {campaignName}:{' '}
          <Box component="b" sx={{ fontWeight: 700 }}>
            {choiceLabel}
          </Box>{' '}
          activated
        </Alert>
      ))}
    </Stack>
  );
}
